import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UtilitiesService {

  parseTime(time: number): string {
    return time < 10 ? `0${time}` : `${time}`;
  }

  objectIsEmpty(obj: any): boolean {
    for (const key in obj) {
      if (obj.hasOwnProperties(key)) {
        if (obj[key] === '' || obj[key] === [] || obj[key] === null || obj[key] === undefined) {
          return false;
        }
      }
    }
    return true;
  }

  findWhere(array: any, objet: string): any {
    let modal: any;
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === objet) {
        modal = array[i];
        break;
      }
    }
    return modal;
  }

  isNullObj(value: object): boolean {
    // return true for value undefined or value null (because undefined == null)
    return value == null;
  }

  isEmptyStr(value: string): boolean {
    // return true for: undefined and null (because undefined == null) && value == ""
    return (value == null || value.length === 0);
  }

  without(array: any, [propertyToRemove]: any): any {
    const array2: any = array;
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < propertyToRemove.length; j++) {
        if (array[i] === propertyToRemove[j]) {
          array2.splice(i, 1);
        }
      }
    }
    return array2;
  }

}
